import { Box, Typography, Avatar, Button } from "@mui/material";
import { useSelector } from "react-redux";
import profile from "../../../assets/images/profile_img.png";
import { colors } from "../../../common/colors";
import { convertUserImage } from "../../../util/utils";
import { UserEntity } from "../../util/editors";

interface Props {
  user: UserEntity;
  isEdit?: boolean;
  onDelete:() => void;
}

function SelectedUser({ user, isEdit = false, onDelete }: Props) {
  const { admin } = useSelector((state: any) => state.adminAuth);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "6px",
        borderRadius: "2px",
        border: `1px solid ${colors.farm_green200}`,
        backgroundColor: "#f9f9f9",
        marginRight: "4px",
        marginBottom: "2px",
      }}
    >
      <Avatar
        sx={{ marginRight: "8px" }}
        src={user?.image ? convertUserImage(user?.image) : profile}
        alt={user?.nickname}
      />

      <Typography
        sx={{
          flexGrow: 1,
          flexShrink: 1,
          minWidth: 0, // Allows text to shrink and ellipsis
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {user?.nickname}&nbsp;
      </Typography>
      {!isEdit && (user.userType !== admin.class_name || user.userId !== admin.id) && (
        <Button
          onClick={onDelete}
          style={{ minWidth: 30, padding: 0, borderRadius: 50 }}
        >
          <img
            alt=""
            style={{ borderRadius: 50, height: 30 }}
            src={require("../../../assets/images/remove_user.png")}
          />
        </Button>
      )}
    </Box>
  );
}

export default SelectedUser;
